export default function () {
    $(function () {
        confirm();
    });
}
export function confirm(){
    const $modal = $('.sl-js-confirm');
    const $modalTitle = $('.sl-js-confirm-title', $modal);
    const $modalConfirmButton = $('.sl-js-confirm-btn', $modal);

// confirm link
    $('a[sl-js-confirm]').on('click', function (e) {
        e.preventDefault();
        $modal.modal({
            backdrop: 'static',
            show: true
        });
        $modalTitle.html($(this).attr('sl-js-confirm'));
        // set original link as submit-link
        $modalConfirmButton.attr('href', $(this).attr('href'));
    });
// confirm form
    let isFormConfirmed = false;
    $('button[sl-js-confirm]', 'form').on('click', function (e) {
        if (!isFormConfirmed) {
            e.preventDefault();
            $modal.modal({
                backdrop: 'static',
                show: true
            });
            $modalTitle.html($(this).attr('sl-js-confirm'));
            const $form = $(this).closest('form');
            $modalConfirmButton.on('click',function (e) {
                e.preventDefault();
                isFormConfirmed = true;
                // submit the form by triggering the click
                // (so that the button is submitted too)
                $('button[sl-js-confirm]', $form).trigger('click');
            });
        }
    });
    $modal.on('hidden.bs.modal', function () {
        // Reset modal href and click when closing to prevent interference with different confirm modals
        $modalConfirmButton.off('click');
        $modalConfirmButton.attr('href', '');
    });
}